<template>
  <flow-part :id="$options.name">
    <template #heading>
      <h2>Welk soort verwarming heb je?</h2>
    </template>
    <template #content>
      <div class="input-group vertical">
        <BigRadioInput id="disctict-heating" v-model="radioOption" name="heating-type" value="districtHeating"
          title="Stads- of blokverwarming" subtitle="Geen eigen cv-ketel of warmtepomp"
          @click="scrollIfPrefilled(radioOption, 'districtHeating')" />
        <BigRadioInput id="heat-pump" v-model="radioOption" name="heating-type" value="heatPump"
          title="Warmtepomp, zonneboiler etc." @click="scrollIfPrefilled(radioOption, 'heatPump')" />
      </div>

      <step-info-toggle title="Waarom moet ik dit invullen?">
        <template #content>
          We gebruiken het type verwarming om een realistisch verbruik uit rekenen. Je elektriciteitsverbruik is
          namelijk lager
          wanneer je stads- of blokverwarming hebt dan in andere situaties.
          <br><br>
          Door dit te vragen schatten we jouw verbruik realistisch in en sluiten de aanbiedingen die je ziet het beste
          aan op jouw situatie.
        </template>
      </step-info-toggle>

      <step-info-toggle title="Kosten stadsverwarming rekenen we niet mee">
        <template #content>
          <strong>Let op:</strong>
          We nemen de kosten van stadsverwarming niet mee in je vergelijking.
          We vragen dit om een realistisch energieverbruik in te kunnen schatten, zodat de prijs van je
          elektriciteitsrekening klopt.
          <br><br>
          Voor stadsverwarming kun je niet van leverancier veranderen. Je kunt wel overstappen van
          elektriciteitsleverancier (en zo kosten besparen).
        </template>
      </step-info-toggle>
    </template>
  </flow-part>
</template>

<script>
import Icon from '../../../../vue-elements/icon/Icon.vue';
import WizardStepMixin from '../../../../vue-elements/wizard/lib/WizardStepMixin.js';
import StepInfoToggle from '../StepInfoToggle.vue';
import FlowPart from '../FlowPart.vue';
import { useEnergyComparisonStore } from '../../stores/energyComparison.js';
import BigRadioInput from '../../../../vue-elements/input/BigRadioInput.vue';

export default {
  name: 'HeatingTypeStep',
  mixins: [WizardStepMixin()],
  components: {
    BigRadioInput,
    FlowPart,
    Icon,
    StepInfoToggle,
  },
  setup() {
    const comparisonStore = useEnergyComparisonStore();

    return {
      comparisonStore,
    };
  },
  computed: {
    radioOption: {
      get() {
        return this.comparisonStore.filters.heatingType;
      },
      set(value) {
        this.comparisonStore.filters.heatingType = value;
      },
    },
  },
  watch: {
    'comparisonStore.filters.heatingType': {
      handler(value) {
        if (value !== null) {
          this.logAnalyticsEvent('compare-energy.wizard-step-complete', {
            step: this.$options.name,
            value,
          });

          this.nextStep();
        }
      },
    },
  },
  created() {
    this.radioOption = this.comparisonStore.filters.heatingType;
  },
  methods: {
    validate() {
      this.status = this.comparisonStore.filters.heatingType !== null && (this.radioOption !== null) ? 'complete' : 'invalid';
    },
  },
};
</script>